import { createContext, useContext } from "react";
import { IAuthManager } from "../shared/AuthManager";

const AuthContext = createContext<IAuthManager | undefined>(undefined);

const useAuth = (): IAuthManager => {
  return useContext(AuthContext) as IAuthManager;
};

interface AuthProviderProps {
  value: IAuthManager;
  children: JSX.Element;
}

const AuthProvider = ({ value, children }: AuthProviderProps): JSX.Element => {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthProvider, useAuth };
